import React, { Component } from 'react';
import FocusBody from 'components/FocusBody';
import Page from 'components/Page';
import logoBlackWide from 'themes/images/logo-black-wide.png';
import FormRow from 'components/FormRow';
import { LabelForInput } from 'components/Label';
import * as Yup from 'yup';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { isEmpty } from 'ramda';
import { pathOr } from 'rambda';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import View from 'components/View';
import { DetailBottomBarConfirm, DetailBottomBarItemButton } from 'components/DetailBottomBarItem';
import DetailBottomBar, { NotificationBar } from 'components/DetailBottomBar';
import Text from 'components/Text';
import Date from 'components/Date';
import Version from 'components/Version';
import Select from '../../components/Select';
import TextInput from '../../components/TextInput';
import FocusContent from '../../components/FocusContent';
import FocusBottomBar from '../../components/FocusBottomBar';
import ImageBottomBar from '../../components/ImageBottomBar';
import Checkbox from '../../components/Checkbox';
import ValidationMessage from '../../components/ValidationMessage';

const registerMutation = gql`
  mutation RegistrationMutation(
    $code: String
    $username: String
    $password: String
    $name: String
    $surname: String
    $bornAt: Date
    $email: String
    $phoneNumber: String
    $address: String
    $infMail: Boolean
    $infApprove: Boolean
    $gender: Genders
  ) {
    consumerActivate(
      data: {
        code: $code
        username: $username
        password: $password
        name: $name
        surname: $surname
        bornAt: $bornAt
        email: $email
        phoneNumber: $phoneNumber
        address: $address
        infMail: $infMail
        infApprove: $infApprove
        gender: $gender
      }
    ) {
      consumer {
        name
        surname
      }
    }
  }
`;

const styles = {
  page: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  text: (props, { components: { FocusPage } }) => ({
    ...FocusPage.text
  }),
  img: {
    marginLeft: 20,
    height: 20
  },
  error: (props, { components: { Login } }) => ({
    ...Login.error,
    justifyContent: 'center',
    alignItems: 'center'
  }),
  regFinishText: {
    padding: '15px',
    width: '420px',
    backgroundColor: '#F1F1F1'
  },
  rowStyle: {
    display: 'flex',
    width: '420px',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  personalDataCheckWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  personalDataCheckHeader: {
    width: '420px'
  },
  withValidationMessageLeft: {
    right: 'calc(100% + 15px)',
    top: '32px'
  },
  withValidationMessageRight: {
    left: 'calc(100% + 15px)',
    top: '32px'
  },
  withApprovalValidationMessage: {
    left: 'calc(100% + 15px)',
    top: '-10px'
  },
  withApprovalValidationMessageNotValidPass: {
    left: 'calc(100% + -60px)',
    top: '32px'
  }
};

export class RegistrationForm extends Component {
  validationSchema = Yup.object().shape({
    name: Yup.string().required('name'),
    surname: Yup.string().required('surname'),
    bornAt: Yup.string().required('bornAt'),
    email: Yup.string().required('email'),
    phoneNumber: Yup.string().required('phoneNumber'),
    username: Yup.string().required('username'),
    password: Yup.string().required('password'),
    verifyPassword: Yup.string()
      .required('verifyPassword')
      .when('password', (password, schema) =>
        schema.test({
          name: 'notVerifiedPassword',
          message: 'notVerifiedPassword',
          test: verifyPassword => verifyPassword === password
        })
      ),
    address: Yup.string().required('address'),
    infApprove: Yup.boolean(),
    infApproveMessage: Yup.string().when(
      'infApprove',
      (infApprove, schema) => (infApprove ? schema : schema.required('infApprove'))
    )
  });

  state = {
    validationErrors: {
      name: false,
      surname: false,
      email: false,
      phoneNumber: false,
      username: false,
      password: false,
      verifyPassword: false,
      address: false,
      infApprove: false,
      notVerifiedPassword: false
    }
  };

  getValidationDefaultState = () => ({
    name: false,
    surname: false,
    email: false,
    phoneNumber: false,
    username: false,
    password: false,
    verifyPassword: false,
    address: false,
    infApprove: false,
    notVerifiedPassword: false
  });

  back = e => {
    const { prevStep } = this.props;
    e.preventDefault();
    prevStep();
  };

  continue = e => {
    const { nextStep } = this.props;
    e.preventDefault();
    nextStep();
  };

  validateForm = afterSuccess => {
    const { values } = this.props;

    this.validationSchema
      .validate(values, { abortEarly: false })
      .then(() => {
        this.setState({ validationErrors: this.getValidationDefaultState() });
        afterSuccess();
      })
      .catch(err => {
        const validationErrors = this.getValidationDefaultState();
        if (err.errors && !isEmpty(err.errors)) {
          err.errors.forEach(error => {
            validationErrors[error] = true;
          });
        }

        this.setState({ validationErrors });
      });
  };

  handleChange = fieldName => e => {
    const { validationErrors } = this.state;
    const { values, handleValueChange } = this.props;
    let fieldValue = {};
    if (fieldName === 'bornAt' && !!e) {
      // fieldValue = moment(e.date);
      // fieldValue = moment(e.date).toISOString();
      // fieldValue = moment(e.date).format('YYYY-MM-DD');
      fieldValue = moment(e).format('YYYY-MM-DD');
    } else if (fieldName === 'infApprove' || fieldName === 'infMail') {
      fieldValue = e.target.checked;
    } else {
      fieldValue = pathOr('', 'target.value', e);
    }

    // only for clear validation window after start typing
    values.name = ' ';
    values.surname = ' ';
    values.bornAt = ' ';
    values.email = ' ';
    values.phoneNumber = ' ';
    values.username = ' ';
    values.password = ' ';
    values.verifyPassword = ' ';
    values.address = ' ';
    values.infApprove = ' ';
    values[fieldName] = fieldValue;
    this.validationSchema
      .validate(values, { abortEarly: false })
      .then(() => {
        handleValueChange(fieldName, fieldValue);
        validationErrors[fieldName] = false;
        this.setState({ validationErrors });
      })
      .catch(err => {
        const updatingValidationErrors = this.getValidationDefaultState();

        if (err.errors && !isEmpty(err.errors)) {
          err.errors.forEach(error => {
            if (error !== 'notVerifiedPassword') {
              updatingValidationErrors[error] = true;
            }
          });
        }

        handleValueChange(fieldName, fieldValue);
        this.setState({ validationErrors: updatingValidationErrors });
      });
  };

  render() {
    const { values, intl } = this.props;

    const getValidationMessageLeft = () => (
      <ValidationMessage
        message={intl.formatMessage({ id: 'general.required-field' })}
        tipPosition="right"
        style={styles.withValidationMessageLeft}
      />
    );

    const getValidationMessageRight = () => (
      <ValidationMessage
        message={intl.formatMessage({ id: 'general.required-field' })}
        tipPosition="left"
        style={styles.withValidationMessageRight}
      />
    );

    const getValidationMessageApproval = () => (
      <ValidationMessage
        message={intl.formatMessage({ id: 'general.required-field' })}
        tipPosition="left"
        style={styles.withApprovalValidationMessage}
      />
    );

    const getValidationMessageNotValidPass = () => (
      <ValidationMessage
        message={intl.formatMessage({ id: 'general.passwords-must-match' })}
        tipPosition="leftright"
        style={styles.withApprovalValidationMessageNotValidPass}
      />
    );

    const { validationErrors } = this.state;

    const DynamicBottomBar = ({ register, loading, error }) => (
      <View style={{ flexDirection: 'column' }}>
        {error && (
          <NotificationBar text={intl.formatMessage({ id: 'errors.unable-to-save-form' })} />
        )}

        <FocusBottomBar>
          <ImageBottomBar>
            <img src={logoBlackWide} alt="LoyalMAN" style={styles.img} />
            <Version position="absolute" />
          </ImageBottomBar>
          <DetailBottomBar withShadow="false">
            <DetailBottomBarItemButton direction="back" onClick={this.back} />

            <DetailBottomBarConfirm
              name={
                loading
                  ? intl.formatMessage({ id: 'registration.registering' })
                  : intl.formatMessage({ id: 'registration.register' })
              }
              onClick={e => {
                this.validateForm(() => {
                  register().then(() => {
                    this.continue(e);
                  });
                });
              }}
            />
          </DetailBottomBar>
        </FocusBottomBar>
      </View>
    );

    return (
      <Page title={intl.formatMessage({ id: 'registration.page-title' })}>
        <View isExpanded style={styles.page}>
          <View style={{ width: 500 }}>
            <FocusContent>
              <FocusBody>
                <View
                  isExpanded
                  isVertical
                  style={{ padding: 40, paddingBottom: 10, alignItems: 'center', width: '100%' }}>
                  <FormRow>
                    <Text style={styles.regFinishText}>
                      {intl.formatMessage({ id: 'registration.subtext' })}
                    </Text>
                  </FormRow>
                  <FormRow>
                    <View style={styles.rowStyle}>
                      {validationErrors.name && getValidationMessageLeft()}
                      <TextInput
                        label={intl.formatMessage({ id: 'registration.name' })}
                        value={values.name}
                        styleBox={{ flexDirection: 'column', alignItems: 'flex-start' }}
                        styleInput={{ width: '200px' }}
                        onChange={this.handleChange('name')}
                      />
                      <View style={{ width: '20px' }} />
                      <TextInput
                        label={intl.formatMessage({ id: 'registration.surname' })}
                        value={values.surname}
                        styleBox={{ flexDirection: 'column', alignItems: 'flex-start' }}
                        styleInput={{ width: '200px' }}
                        onChange={this.handleChange('surname')}
                      />
                      {validationErrors.surname && getValidationMessageRight()}
                    </View>
                  </FormRow>
                  <FormRow>
                    <View style={styles.rowStyle}>
                      {validationErrors.bornAt && getValidationMessageLeft()}
                      <Date
                        isVertical
                        label={intl.formatMessage({ id: 'registration.bornAt' })}
                        name="bornAt"
                        width={200}
                        initialDate={values.bornAt}
                        onDateChange={d => {
                          if (d) this.handleChange('bornAt')(d);
                        }}
                      />
                      <View style={{ width: '20px' }} />
                      <Select
                        name="gender"
                        value={values.gender}
                        onChange={this.handleChange('gender')}
                        label={intl.formatMessage({ id: 'registration.gender' })}
                        labelStyle={{ width: '200px' }}>
                        <option value="MALE">
                          {intl.formatMessage({ id: 'registration.gender.male' })}
                        </option>
                        <option value="FEMALE">
                          {intl.formatMessage({ id: 'registration.gender.female' })}
                        </option>
                      </Select>
                    </View>
                  </FormRow>
                  <FormRow>
                    <View style={styles.rowStyle}>
                      {validationErrors.email && getValidationMessageLeft()}
                      <TextInput
                        label={intl.formatMessage({ id: 'registration.email' })}
                        value={values.email}
                        styleBox={{ flexDirection: 'column', alignItems: 'flex-start' }}
                        styleInput={{ width: '200px' }}
                        onChange={this.handleChange('email')}
                      />
                      <View style={{ width: '20px' }} />
                      <TextInput
                        label={intl.formatMessage({ id: 'registration.phone' })}
                        value={values.phone}
                        styleBox={{ flexDirection: 'column', alignItems: 'flex-start' }}
                        styleInput={{ width: '200px' }}
                        onChange={this.handleChange('phoneNumber')}
                      />
                      {validationErrors.phoneNumber && getValidationMessageRight()}
                    </View>
                  </FormRow>
                  <FormRow>
                    <View style={styles.rowStyle}>
                      {validationErrors.username && getValidationMessageLeft()}
                      <TextInput
                        label={intl.formatMessage({ id: 'registration.username' })}
                        value={values.username}
                        styleBox={{ flexDirection: 'column', alignItems: 'flex-start' }}
                        styleInput={{ width: '200px' }}
                        onChange={this.handleChange('username')}
                      />
                    </View>
                  </FormRow>
                  <FormRow>
                    <View style={styles.rowStyle}>
                      {validationErrors.password && getValidationMessageLeft()}
                      <TextInput
                        label={intl.formatMessage({ id: 'registration.password' })}
                        value={values.password}
                        styleBox={{ flexDirection: 'column', alignItems: 'flex-start' }}
                        styleInput={{
                          width: '200px',
                          '-webkit-text-security': 'disc',
                          '-moz-text-security': 'disc',
                          textSecurity: 'disc'
                        }}
                        nativeProps={{
                          value: values.password,
                          onChange: this.handleChange('password')
                        }}
                      />
                      {validationErrors.notVerifiedPassword && getValidationMessageNotValidPass()}
                      <View style={{ width: '20px' }} />
                      <TextInput
                        label={intl.formatMessage({ id: 'registration.passwordConfirmation' })}
                        styleBox={{ flexDirection: 'column', alignItems: 'flex-start' }}
                        styleInput={{
                          width: '200px',
                          '-webkit-text-security': 'disc',
                          '-moz-text-security': 'disc',
                          textSecurity: 'disc'
                        }}
                        nativeProps={{
                          value: values.verifyPassword,
                          onChange: this.handleChange('verifyPassword')
                        }}
                      />
                      {validationErrors.verifyPassword && getValidationMessageRight()}
                    </View>
                  </FormRow>
                  <FormRow>
                    <TextInput
                      label={intl.formatMessage({ id: 'registration.address' })}
                      value={values.address}
                      styleBox={{ flexDirection: 'column', alignItems: 'flex-start' }}
                      styleInput={{ width: '420px' }}
                      onChange={this.handleChange('address')}
                    />
                    {validationErrors.address && getValidationMessageRight()}
                  </FormRow>
                  <FormRow>
                    <View style={styles.personalDataCheckWrapper}>
                      <LabelForInput width="420px">
                        {intl.formatMessage({ id: 'registration.personal-data' })}
                      </LabelForInput>
                      <View style={{ padding: '10px 0px' }}>
                        <Checkbox
                          label={intl.formatMessage({ id: 'registration.personal-data.confirm' })}
                          checked={values.infApprove}
                          onChange={this.handleChange('infApprove')}
                        />
                        {validationErrors.infApprove && getValidationMessageApproval()}
                      </View>
                      <Checkbox
                        label={intl.formatMessage({ id: 'registration.info-email.confirm' })}
                        checked={values.infMail}
                        onChange={this.handleChange('infMail')}
                      />
                    </View>
                  </FormRow>
                </View>

                <Mutation mutation={registerMutation} variables={values} onCompleted={() => {}}>
                  {(register, { error, loading }) => (
                    <DynamicBottomBar register={register} loading={loading} error={error} />
                  )}
                </Mutation>
              </FocusBody>
            </FocusContent>
          </View>
        </View>
      </Page>
    );
  }
}

export default injectIntl(RegistrationForm);
